var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-collapse--line"},[_c('div',{class:_vm.itemContainerClass},[_c('div',{staticClass:"c-modal--body--item"},[_vm._t("form"),_vm._v(" "),_vm._t("label")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }